module.exports = __webpack_public_path__ + "images/offer-white-placeholder.f13140e7.png";